import React from 'react'
import Head from '../../components/Head'

export default (props) => (
  <div>
    <Head {...props} />
    <section className="rex-content">
        <h3>Get Started with the Retail Express API</h3>
        <p>The documentation in this portal relates to new Retail Express API which currently provides access to Financial Summary data, generally for the purpose of integrating financial data to an accounting package. </p>

        <p>If you are trying to access information about our legacy APIs (Inventory Planning, Warehouse Management, Webstore), please refer to our Web Services Overview documentation available <a href="https://ress.zendesk.com/hc/en-us/article_attachments/205468688/WebServices_Overview.pdf" target='_blank'>here</a>.</p>
        
        <p>To access the Retail Express API you will need a license for the API and an API Key. To arrange your API Key, please speak to our Sales team on 1300 732 618.</p>
        
        <p>Once you have an API Key, you can explore our APIs using the API Explorer to see details about what endpoint does and to understand the request and response format for each method. You will need to use the API Key as the x-api-key header in your requests.</p>
        
        <p>If you have any questions about the Retail Express API, please contact our Support team via <a href="mailto:support@retailexpress.com.au">support@retailexpress.com.au</a>.</p>
    </section>
  </div>)



// WEBPACK FOOTER //
// ./src/pages/GettingStarted/index.js